require('./dist/react-sidebarjs.css');

module.exports = require('./dist/react-sidebarjs.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-sidebarjs/index.js
// module id = 75
// module chunks = 0